<template>
  <el-dialog
    v-drag
    title="已分配银行账号"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <div class="opt">
      <div class="btn" @click="add"><i class="el-icon-circle-plus-outline" />分配</div>
    </div>
    <BaseTable
      style="margin-top: 10px"
      :height="360"
      :tableData="tableData"
      :loading="loading"
      :isPager="false"
    >
      <template slot="opt" slot-scope="row">
        <i class="el-icon-delete icon" @click="remove(row.scope)" />
      </template>
    </BaseTable>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok()">确 定</div>
    </span>
    <BankAccountDistributionDialog
      :dialogVisible="dialogVisible1"
      :editData="editData"
      :usedList="tableData.columns"
      @cancel="dialogVisible1 = false"
      @ok="ok1">
    </BankAccountDistributionDialog>
  </el-dialog>
</template>
<script>
const BaseTable = () => import('@/components/table/BaseTable')
import BankAccountDistributionDialog from './BankAccountDistributionDialog'
import { companyBankAccount } from '@/api/fee'
import { deleteBankAccountCompany } from '@/api/fee'

export default {
  components: { BaseTable, BankAccountDistributionDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: function() {
        return {
        }
      },
      require: true
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'bankName',
            label: '账户名称',
            width: '140'
          },
          {
            filed: 'accountHolder',
            label: '开户人',
            width: '140'
          },
          {
            filed: 'accountNumber',
            label: '银行账号',
            width: '200'
          },
          {
            filed: 'creditAmount',
            label: '账户类型',
            width: '140',
            formatter: row => row.type === 0 ? '银行卡' : ''
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '60',
            isCustom: true
          }
        ],
        columns: []
      },
      loading: false,
      dialogVisible1: false
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await companyBankAccount({
          companyId: this.editData.companyId
        })
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    add() {
        this.dialogVisible1 = true
    },
    async remove(row) {
      try {
        const res = await deleteBankAccountCompany({ id: row.id })
        if (res.success) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    ok() {
      this.$emit('ok')
    },
    ok1() {
        this.dialogVisible1 = false
        this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.opt {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  .btn {
    width: 80px;
    height: 30px;
    background: #35ba83;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
  }
}
.icon {
  color: rgba(35, 149, 243, 1);
  font-size: 20px;
  cursor: pointer;
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
